@if ({ vm: crcEmail$ | async }; as crcEmail) {
    <div>
        @if (isEditing) {
            <div class="o-grid" [formGroup]="parentFormGroup">
                <div class="o-grid__row">
                    <div class="o-grid__field">
                        <mds-text-field
                            id="primaryCrc"
                            [formCtrl]="crcEmailControl"
                            placeholder="Type here..."
                            appearance="outline"
                            inputType="text"
                            label="Primary CRC"
                            width="100%"
                            [required]="true"
                            (input)="emitStringChange($event, { id: 'primaryCrcEmailToInvite' })"
                        ></mds-text-field>
                    </div>
                </div>
            </div>
        }
        @if (!isEditing && !loaderSpinner) {
            <div class="o-grid">
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Primary CRC Email</h5>
                            <span>{{ !!crcEmail.vm ? crcEmail.vm : 'N/A' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (!isEditing && loaderSpinner) {
            <div class="o-grid">
                <medpace-loading-card></medpace-loading-card>
            </div>
        }
    </div>
}
